import config from "../../config";
import Header from "../../components/Header";
import Head from "next/head";
import VideoCardSmall from "../../components/VideoCardSmallOld";
import Footer from "../../components/Footer";
import React from "react";
import HeaderExtension from "../../components/HeaderExtension";

export default function Category({ category, categories }) {
  console.log(category, categories);

  let categoryText = category ? category.charAt(0).toUpperCase() + category.slice(1) : " ";
  return (
    <div className="bg-blue-light  absolute w-full  min-h-screen">
      <Head>
        <title>Automate.video | {categoryText}</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header />
      <HeaderExtension title={categoryText} />
      <div className="container relative px-2 mx-auto mt-6 w-full mb-120">
        <div className="flex flex-row items-center">
          <div className="flex flex-col "> </div>
          <div className="flex flex-col flex-initial align-center mx-auto  ">
            {categories
              ? categories.map((c) => {
                  return (
                    <React.Fragment>
                      <div className="inline-flex flex-row flex-auto flex-wrap gap-3 mt-2 justify-center">
                        {c.projects.map((p) => {
                          return <VideoCardSmall {...p} key={p.projectid} />;
                        })}
                        <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
                        <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
                        <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
                        <div style={{ opacity: 0, cursor: "default", width: 200, height: 0, marginBottom: 0 }}></div>
                      </div>
                    </React.Fragment>
                  );
                })
              : null}
          </div>
          <div className="flex flex-col flex-grow"> </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export async function getStaticPaths() {
  // Call an external API endpoint to get posts
  const res = await fetch(`${config.socketIo}/api/getAllFeaturedCategories`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });

  const posts = await res.json();

  // Get the paths we want to pre-render based on posts
  const paths = posts.map((post) => `/browse/${post.path}`);

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  let categories = [];
  let categoryNameLowercase = params.category.replace(/-/g, " ");
  let categoryName = categoryNameLowercase.split(" ").map(capitalize).join(" ");
  const featuredCategories = [categoryNameLowercase];
  //console.log(featuredCategories);
  for (let f of featuredCategories) {
    const res = await fetch(`${config.socketIo}/api/getPublicCategoryFeatured`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ categoryFeatured: f, limit: 100 }),
    });
    const data = await res.json();
    //console.log(JSON.stringify(data, null, 2));
    let category = { categoryFeatured: f, projects: [] };
    for (let d of data) {
      category.projects.push({
        projectid: d.projectid,
        projectUrl: "/" + d.projectid,
        name: d.name,
        previewImageUrl: d.urls.previewImageUrl,
        created: d.created,
      });
    }
    categories.push(category);
  }
  console.log(JSON.stringify(categories));
  return { props: { category: categoryName, categories: categories }, revalidate: 3600 };
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
